// start:ng42.barrel
import './fees-dashboard.component';
// end:ng42.barrel

